(function() {

  'use strict';

  angular.module('eclipseApp.myAccount').controller('downloadInvoiceCSVExcelCtrl', ['$scope', '$http', 'uteEndpoint', 'data', '$window', function($scope, $http, uteEndpoint, data, $window) {
    var accountNumber = data.accountNumber;
    var content_id = data.content_id;
    var header =  data.header;
    var tokenForDownloadOtherFormat = '';
    $scope.init = function(){
      var config = {
        cmsBase: '/bbapp/bbcms'
        , fromReceiveDate: '2013-10-10'
        , appID: 'Fido.ca'
        , timeoutUserSummary: '5000'
        , timeoutDocuments: '10000'
      };
      BBAPI.setConfig(config);
        $http({
          method: 'POST',
          url: uteEndpoint('olb/retrieveBBToken'),
          data: {
              accountNumber: accountNumber
          }
        }).success(function(tokenNumber) {
          if (tokenNumber){
            tokenForDownloadOtherFormat = tokenNumber.token;
            $http({
              method: 'GET',
              headers: {
                'Accept': $scope.headerFormat
              },
              url: "rogers_rest/rogers/document/" + content_id + "/usage/details/?EncryptedToken=" + encodeURIComponent(tokenForDownloadOtherFormat)
            }).success(function(data){
              console.log("success");
            }).error(function(data){
              console.log("error");
            })
          }
        });
    }
    $scope.init();
  }]);

})();
